/** @jsxImportSource @emotion/react */
import { Button } from "@coreai/component-library";
import { useLanguage } from "LanguageContext";
import Accordion from "../components/MainComponents/FAQ/Accordion";
import Loader from "../components/MainComponents/Loader/Loader";
import TableOfContents from "../components/MainComponents/FAQ/TableOfContent";
import { useFaqService } from "../services/useFaqService";
import ReactMarkdown from "react-markdown";
import { css, useTheme } from "@emotion/react";

export default function HelpPage() {
  const theme = useTheme();
  const { faqData, loading, error } = useFaqService();
  const { t } = useLanguage();
  const parts = faqData?.categories_faqs?.sort((a,b)=> a?.position - b?.position).map((category) => ({
    id: category?.slug,
    title: category?.title,
    position: category?.position,
  }));

  const titleStyles = css`
    font-size: ${theme.typography.heading2_semiBold.fontSize};
    margin-top: ${theme.spacing["5xl"]};
    margin-bottom: ${theme.spacing.xl};
    font-family: ${theme.typography.heading2_semiBold.fontFamily};
    font-weight: ${theme.typography.heading2_semiBold.fontWeight};
    color: ${theme.colors.textMedium};
  `;

  const summaryStyles = css`
    padding: ${theme.spacing.lg} 0;
    margin-bottom: ${theme.spacing["4xl"]};
    h2 {
      font-size: ${theme.typography.heading3_medium.fontSize};
      margin-bottom: ${theme.spacing.lg};
      font-family: ${theme.typography.heading3_medium.fontFamily};
      font-weight: ${theme.typography.heading3_medium.fontWeight};
      color: ${theme.colors.textDark};
    }
    ol {
      list-style-type: decimal;
      margin-left: ${theme.spacing.lg};
      li {
        margin-bottom: ${theme.spacing.sm};
        a {
          color: ${theme.colors.textMedium};
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  `;

  const contactSectionStyles = css`
    text-decoration: none;
    border-radius: 8px;
    padding: 16px;
    position: relative;
    background-color: #fff;
    color: inherit;
    padding: ${theme.spacing.xxl};
    position: relative;
    font-size: 20px;
    text-align: center;
    margin-top: ${theme.spacing["4xl"]};
    box-shadow: ${theme.shadows.shallow};
  `;

  const buttonContact = css`
    margin-top: ${theme.spacing.xl};
  `;
  if (loading) return <div className="loaderPage"> <Loader /> </div>;
  if (error) return <div className="loaderPage"> <div>Error</div> </div>;
  return (
    <>
      <div>
        <div css={titleStyles}>{faqData?.pageTitle}</div>
        <div css={summaryStyles}>
          <TableOfContents
            summary_title={faqData?.summary_title ?? ""}
            items={parts ?? []}
          />
        </div>
        <div css={contactSectionStyles}>
          {faqData?.paragraph &&  <ReactMarkdown
              className="reference-card-description"
              components={{
                a: ({ href, children }) => (
                  <a href={href} target="_blank">
                    {children}
                  </a>
                ),
              }}
            >
              {faqData?.paragraph}
            </ReactMarkdown>
            }
          <Button
            css={buttonContact}
            variant="brand"
            icon={"mail"}
            onClick={() => {
              window.location.href = `mailto:${faqData?.contactButton.email}`;
            }}
            className="brandPrimaryBtn"
          >
            {faqData?.contactButton.text}
          </Button>
        </div>
        {faqData && <Accordion categories={faqData?.categories_faqs || []} />}
      </div>
    </>
  );
}
